import * as React from 'react';
import {AdaptivityProvider, AppRoot, ConfigProvider} from '@vkontakte/vkui';
import App from './App';
import {createRoot} from 'react-dom/client';
import {RouterProvider} from "@vkontakte/vk-mini-apps-router";
import {router} from "./routing/routing";
import {
    getTelegramPlatform,
    getTelegramSafeAreaInsets,
    initTelegramWebApp,
    isTelegramWebAppAvailable
} from "./services/telegramWebApp";
import "./css/index.css";

initTelegramWebApp();

const Root = () => {
    const isTelegramWebApp = isTelegramWebAppAvailable();
    const safeAreaInsets = getTelegramSafeAreaInsets();
    const tgPlatform = getTelegramPlatform();
    const vkuiPlatform = tgPlatform === "ios" || tgPlatform === "macos" ? "ios" : "android";

    return (
        <ConfigProvider
            appearance={"light"}
            platform={isTelegramWebApp ? vkuiPlatform : undefined}
            isWebView={isTelegramWebApp}
            hasCustomPanelHeaderAfter={false}
        >
            <AdaptivityProvider>
                <AppRoot mode="full" safeAreaInsets={safeAreaInsets}>
                    <RouterProvider router={router}>
                        <App/>
                    </RouterProvider>
                </AppRoot>
            </AdaptivityProvider>
        </ConfigProvider>
    );
};

const root = createRoot(document.getElementById("root"));
root.render(<Root/>);

// if (process.env.NODE_ENV === "development") {
    import("./eruda").then(({default: eruda}) => {});
// }
